import { render, staticRenderFns } from "./message_status.vue?vue&type=template&id=608b5d48"
import script from "./message_status.vue?vue&type=script&lang=ts"
export * from "./message_status.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports